import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormGroup } from '@angular/forms';
import { UserGenericService } from './userGeneric.service';
import { UserService } from '../user/user.service';
import { NotificationService} from 'app/shared/notification/notification.service';
import { UserGeneric } from 'app/userGeneric/userGeneric';
import { AuthUser } from '../auth/authUser';

@Component({
	template: `
		<h3 class="title" i18n="@@update-pass">Update password</h3>

		<form *ngIf="form" [formGroup]="form" (ngSubmit)="update()">
			<fieldset class="fieldset">
				<legend class="legend" i18n="@@data-account">Account data</legend>

				<div class="field-row">
					<div class="field-row-item">
						<label class="label" for="password" i18n="@@password">Password</label>
						<input formControlName="password" type="password" autocomplete="off">
						<validator [control]="form.controls['password']"></validator>
					</div>
					<div class="field-row-item">
						<label class="label" for="passwordConfirm" i18n="@@passwordConfirm">Password confirm</label>
						<input formControlName="passwordConfirm" type="password" autocomplete="off">
						<validator [control]="form.controls['passwordConfirm']"></validator>
					</div>
				</div>
			</fieldset>

			<div class="options">
				<button class="btn-text" type="submit" [disabled]="!form.valid">
					<span i18n="@@option-save">Save</span>
				</button>
			</div>
		</form>
	`
})
export class UserGenericUpdatePasswordComponent implements OnInit {
	form: FormGroup;

	constructor(
		private router: Router,
		private activatedRoute: ActivatedRoute,
		private userGenericService: UserGenericService,
		private userService: UserService,
		private notificationService: NotificationService
	) {}

	ngOnInit() {
		this.activatedRoute.parent.params.subscribe(params => {
			let userGeneric = new UserGeneric();
			userGeneric.id = params['userGenericId'];
			userGeneric.authUser = new AuthUser();
			this.form = this.userGenericService.toFormGroupUpdatePassword(userGeneric);
		});
	}

	update() {
		this.userService.updatePassword(this.form.value).subscribe(userGeneric => {
			this.notificationService.sucessUpdate(userGeneric.firstName + ' ' + userGeneric.lastName);
			this.router.navigate([`../`], {relativeTo: this.activatedRoute});
		}, err => this.notificationService.error(err));
	}
}
